// src/config/imagePath.js

/**
 * dynamically generates the image URL.
 * 1. Checks if WordPress plugin has provided a specific URL.
 * 2. Falls back to local folder for testing.
 */
export const getImagePath = (relativePath) => {
    // Check if we are live on WordPress (plugin active)
    if (window.anrSettings && window.anrSettings.imageBaseUrl) {
        // Ensure no double slashes (e.g. url//mounts)
        const baseUrl = window.anrSettings.imageBaseUrl.replace(/\/$/, '');
        const cleanPath = relativePath.replace(/^\//, '');
        return `${baseUrl}/${cleanPath}`;
    }
    
    // Fallback: Local Development (localhost)
    // Assumes your images are in public/anr-builder/images/
    return `/anr-builder/images/${relativePath.replace(/^\//, '')}`;
};